import * as yup from 'yup';

// Copied from PersonalDetailsDE.schema.ts — keep in sync if the desktop rule changes.
export const privacyConsentSchema = yup.object().shape({
  privacyPolicyAgreement: yup
    .boolean()
    .required('benötigt')
    .oneOf([true], 'benötigt'),
});
